import { render, staticRenderFns } from "./borrowMoney.vue?vue&type=template&id=c41ffd28&scoped=true"
import script from "./borrowMoney.vue?vue&type=script&lang=js"
export * from "./borrowMoney.vue?vue&type=script&lang=js"
import style0 from "./borrowMoney.vue?vue&type=style&index=0&id=c41ffd28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41ffd28",
  null
  
)

export default component.exports